export const selectById = (entities, id) => {
  return entities.find(entity => +entity.id === +id) || null;
};



/** WEBPACK FOOTER **
 ** ./src/selectors/entities.js
 **/